import { Tooltip } from "antd";
import React, { useCallback } from 'react';
import Icon, { ICON_NAME } from "../../../../../components/Icon";
import { openPopup } from "../../../../../components/Popup/_components/WrapperPopup";
import { selectPermissions } from '../../../../../util/store/selectors';
import { useSelector } from "../../../../../util/store/store";
import { ACTION } from "../../../../../util/varibles/permission";
import PopupClear from "../../../Popup/Clear";
import { selectPlan } from "../../../constants";

const RemoveOps: React.FC = () => {
    const vessels = useSelector(selectPlan.vessels);
    const [canClearOperations] = useSelector(selectPermissions([ACTION.PLAN_OP.CLEAR]));

    const handleClick = useCallback(() => {
        const ids = vessels.reduce((list: any, { id, isShow }: any) => {
            if (isShow)
                list.push(id);
            return list;
        }, [])
        const div = openPopup(<PopupClear vesselIds={ids} onClose={() => div.remove()} />);
    }, [vessels]);

    if (!canClearOperations)
        return null;

    return <Tooltip title="Remove operations">
        <div
            data-danger='true'
            className='bt-ghost'
            data-icon={true}
            onClick={handleClick}
        >
            <Icon icon={ICON_NAME.DELETE} size='large' danger />
        </div>
    </Tooltip>;
};

export default RemoveOps;
